import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useCurrentRouteType } from '@/common/hooks';
import { AppRouterTypes } from '@/common/interfaces';

interface AppPaginationProps {
  pageParam: number;
  handleChangePage: (page: number) => void;
}

export const useAppPagination = (): AppPaginationProps => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [pageParam, setPageParam] = useState(
    !searchParams.get('page') || (!!searchParams.get('page') && Number(searchParams.get('page')) < 1)
      ? 1
      : Number(searchParams.get('page'))
  );

  // let pageParam = useMemo(
  //   () => (searchParams.get('page') ? Number(searchParams.get('page')) : null),
  //   [searchParams.get('page')]
  // );

  // useEffect(() => {
  //   if (!searchParams.get('page')) {
  //     setSearchParams({ page: pageParam.toString() }, { replace: true });
  //   }
  //   // if (pageParam) {
  //   //   if (pageParam < 1) setPageParam(1);
  //   // } else {
  //   // }
  // }, []);

  // useEffect(() => {
  //   console.log(pageParam);

  //   if (pageParam) {
  //     if (pageParam < 1) setPageParam(1);
  //   } else {
  //     // setSearchParams({ page: pageParam.toString() }, { replace: true });
  //   }
  // }, [pageParam]);

  const { routeType } = useCurrentRouteType();

  const handleChangePage = useCallback(
    (page: number): void => {
      setPageParam(page);
      if (routeType === AppRouterTypes.Common) {
        setSearchParams({ page: page.toString() });
      }
    },
    [routeType]
  );

  return {
    pageParam,
    handleChangePage
  };
};
